import $ from 'jquery';

import '../../../scss/app/home.scss';


// Home panel audio
const homePanel = document.querySelector('.home-panel');
const homePanelAudio = document.getElementById('home-panel-audio');
const homePanelAudioToggle = document.getElementById('home-panel-audio-toggle');

if (homePanelAudio && homePanelAudioToggle) {
  const $playIcon = $(homePanelAudioToggle).find('.play');
  const $pauseIcon = $(homePanelAudioToggle).find('.pause');
  homePanelAudio.addEventListener('pause', () => {
    $playIcon.removeClass('visible');
    $pauseIcon.addClass('visible');
  });
  homePanelAudio.addEventListener('play', () => {
    $playIcon.addClass('visible');
    $pauseIcon.removeClass('visible');
  });
  if (homePanelAudio.hasAttribute('data-autoplay')) {
    homePanelAudio.play();
  }
  homePanelAudioToggle.addEventListener('click', () => {
    if (homePanelAudio.paused) {
      homePanelAudio.play();
    } else {
      homePanelAudio.pause();
    }
  });
}
